export const categories = [
  { id: 'всі', name: 'Всі', emoji: '🕯️' },
  { id: 'ароматичні', name: 'Ароматичні', emoji: '🌸' },
  { id: 'декоративні', name: 'Декоративні', emoji: '✨' },
  { id: 'релакс', name: 'Релакс', emoji: '🧘‍♀️' },
  { id: 'святкові', name: 'Святкові', emoji: '🎄' },
];

export default categories;
